import ExitPopUp from "../utils/exitPopUp";

function isABTest(testName) {
  window.dataLayer = window.dataLayer || [];
  // If enabled this will show the active tests menu
  // allowing you to toggle between tests
  const urlParams = new URLSearchParams(window.location.search);
  let showTestsMenu = false;
  if (urlParams.has('abtest')) {
    showTestsMenu = true;
  }

  if (showTestsMenu && !document.querySelector('.cro-tests')) {
    // Create and add active tests menu
    const croTests = document.createElement('div');
    croTests.classList.add('cro-tests');
    const croHTML = `<div class='cro-tests__tests'></div>
                    <div class='cro-tests__trigger'>
                      <h4>A/B Tests</h4>
                    </div>`;
    croTests.innerHTML = croHTML;
    document.body.appendChild(croTests);

    // Open / Close tests menu
    document.querySelector('.cro-tests__trigger').addEventListener('click', () => {
      const testsMenu = document.querySelector('.cro-tests');
      const triggerText = document.querySelector('.cro-tests__trigger h4');
      testsMenu.classList.toggle('cro-tests__open');
      triggerText.innerText = testsMenu.classList.contains('cro-tests__open') ? 'Close' : 'A/B Tests';
    });
  }

  const toggleCookie = (testName, isActive) => {
    const group = 1 - isActive;
    document.cookie = `test-${testName}=${group};path=/;max-age=31536000`;
    ExitPopUp.Disable();
    window.location.reload();
  };

  const addToList = (testName, isActive) => {
    const croTests = document.querySelector('.cro-tests');
    if (!croTests.getElementsByClassName(`${testName}-cookie`)[0]) {
      const croList = document.querySelector('.cro-tests__tests');

      const croTest = `<div class='${testName}-cookie test-item'>
                        <p>
                          <button class='btn btn--${isActive ? 'active' : 'inactive'}'></button>
                          <span>${testName}</span>
                        </p>
                      </div>`;

      croList.insertAdjacentHTML('beforeend', croTest);

      document.querySelector(`.${testName}-cookie button`).addEventListener('click', () => {
        toggleCookie(testName, isActive);
      });
    }
  };

  // get all cookies
  const cookie = document.cookie;
  // check if cookie for test exists and fire data layer events and return true or false
  if (cookie.includes(`${testName}=1`)) {
    window.dataLayer.push({
      event: 'abtest',
      test: {
        name: testName,
        group: 'variant',
      },
    });
    document.body.classList.add(testName);
    if (showTestsMenu) addToList(testName, 1);
    return true;
  } else if (cookie.includes(`${testName}=0`)) {
    window.dataLayer.push({
      event: 'abtest',
      test: {
        name: testName,
        group: 'control',
      },
    });
    if (showTestsMenu) addToList(testName, 0);
    return false;
  } else {
    // if no cookie exists for 'testName' then generate group (control or variant) and create cookie
    const group = Math.random() < 0.5 ? 1 : 0;
    document.cookie = `test-${testName}=${group};path=/;max-age=31536000`;

    if (group === 1) {
      document.body.classList.add(testName);
    }

    window.dataLayer.push({
      event: 'abtest',
      test: {
        name: testName,
        group: group === 1 ? 'variant' : 'control',
      },
    });
    if (showTestsMenu) addToList(testName, group);
    return group === 1;
  }
}

export default isABTest;
